import React, {Suspense} from 'react';
import * as firebase from 'firebase';
import './App.css';
import { makeStyles,createTheme, ThemeProvider } from '@material-ui/core/styles';

import Container from './components/Container'
import CircularProgress from '@material-ui/core/CircularProgress';
import {BrowserRouter as Router,Switch, Route} from 'react-router-dom'
import SellerForm from './SellerSide/SellerForm'
import CustomerFrom from './CustomerSide/CustomerForm'

import Dashboard from './Dashboard/Dashboard'


// const SellerForm = React.lazy(() => import( './SellerSide/SellerForm'))
// const CustomerFrom = React.lazy(() => import('./CustomerSide/CustomerForm'))

// const Dashboard = React.lazy(() => import( './Dashboard/Dashboard'))

// LogRocket.init('naxgbo/meintankpreis',{mergeIframes: true});

const firebaseConfigPilot = {
  apiKey: "AIzaSyAf6AuspN2TOYRVNrEFHhIB3J5Q_-zeN2s",
  authDomain: "meintankpreis.firebaseapp.com",
  databaseURL: "https://meintankpreis.firebaseio.com",
  projectId: "meintankpreis",
  storageBucket: "meintankpreis.appspot.com",
  messagingSenderId: "773765249178",
  appId: "1:773765249178:web:b616b0447b7098f87b4723",
  measurementId: "G-VF0835VQ4D"
};
const firebaseConfigTesting = {
  apiKey: "AIzaSyBfJuOKtg9sYpZ0q5V93xQXgBrqqR5tCqM",
  authDomain: "meintankpreis-testing.firebaseapp.com",
  projectId: "meintankpreis-testing",
  storageBucket: "meintankpreis-testing.appspot.com",
  messagingSenderId: "693866170285",
  appId: "1:693866170285:web:f50b7bb5ae27e86b468324",
  measurementId: "G-8CX7KDR5SP"
};

const firebaseConfigProduction = {
  apiKey: "AIzaSyAc_NOdpvW0Y7agURZEM6jvIBD_z8ID2qA",
  authDomain: "meintankpreis-production.firebaseapp.com",
  projectId: "meintankpreis-production",
  storageBucket: "meintankpreis-production.appspot.com",
  messagingSenderId: "865971281920",
  appId: "1:865971281920:web:bb144d2a1a2ba6e699b8e5",
  measurementId: "G-X1S9WMFMHZ"
};

firebase.initializeApp(firebaseConfigProduction)

const useStyles = makeStyles((theme) => ({
  root: {
    left: '50%',
     marginLeft: '-4em'
  },
}));
const theme2 = createTheme({
  palette:{
      primary:{
          light:'#041556',
          main:'#061e7b',
          dark: '#374b95',
      },
      secondary:{
          light:'#b26500',
          main:'#ff9100',
          dark: '#ffa733',
      },
      type:'dark',
  }
});


function App() {
  const classes = useStyles();
  return (
    
    
    <Router>
    <Suspense fallback={
    <div className={classes.root}>
      <CircularProgress color="secondary" />
    </div>
    }>
      <Switch>
          <Route path='/dashboard'>
          <ThemeProvider theme={theme2}>
            <Dashboard/>
          </ThemeProvider>
          </Route>
          <Route path='/seller'>
          <Container>
          <SellerForm/>
          </Container>
          </Route>
          {/* <Route path='/embed'>
          <Container>
          <HeaderForm/>
            </Container>
          </Route> */}
          <Route path='/'>
          <Container>
            <CustomerFrom/>
          </Container>
          </Route>
        </Switch>
        </Suspense>
    </Router>
      
    
    
  );
}

export default App;
